import { Injectable } from '@angular/core';
import { CanActivate,Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExclusiveGuard implements CanActivate {
  constructor(private router:Router ) {
 
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let tab_data = JSON.parse(localStorage.getItem('tab_data'));
      let tabs = JSON.parse(localStorage.getItem('tabs'));
     
      let is_tab_exist = tabs.find(o => (o.slug).toLowerCase() == (route.params.name).toLowerCase());
      if(is_tab_exist) {
        return true;
      }
      if(!tab_data || route.params.name !=tab_data.url_slug  ) {
        window.location.href = '404'
        return false;
      }
      return true;
  }
  
}
